import { STREAM_HEIGHT, STREAM_HEIGHT_COMPACT } from '@app/modules/logger/screens/status/constants';
import WifiTetheringOffIcon from '@mui/icons-material/WifiTetheringOff';
import { Box, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useStatusViewContext } from '../../../context/StatusViewContext';

export const NoActivityMessage = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact: boolean }>`
  text-align: center;
  color: #ccc;
  font-weight: 400;
  width: auto;
  margin: 0;
  font-size: ${(p) => (p.compact ? '0.875rem' : '1.1rem')};
`;

/**
 * Component that displays a message when there's no recent activity registered for a station.
 */
export function StatusNoActivityMessage() {
  const { compact } = useStatusViewContext();
  const height = compact ? STREAM_HEIGHT_COMPACT : STREAM_HEIGHT;
  const iconSize = compact ? 40 : 64;

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height,
      }}
    >
      <WifiTetheringOffIcon
        sx={{
          fontSize: iconSize,
          color: '#ccc',
          mb: compact ? 1 : 2,
        }}
      />
      <NoActivityMessage compact={compact}>
        <FormattedMessage
          id="logger.statusScreen.noActivity"
          defaultMessage="Sin emisión reciente registrada"
        />
      </NoActivityMessage>
    </Box>
  );
}
